module.exports = __webpack_public_path__ + "img/logo.a09ff68b.png";